import React from 'react';
import { Row, Col, Card, ProgressBar } from 'react-bootstrap';
import photographer from '../../../images/camera-man.png';

const Progress = () => {
    return (
        <div className='m-5 '>
            <h2 className='mb-4'>Categories Progress</h2>
            <Row xs={1} md={2} lg={2} className="g-4">
                <Col>
                    <Card className='border-0'>
                        <Card.Img variant="top" src={photographer} />
                    </Card>
                </Col>

                <Col>
                    <Card className='border-0'>
                        <Card.Body>
                            <Card.Title className='text-center'>Build A Moment With One Snap Shoot</Card.Title>
                            <Card.Text style={{ textAlign: 'justify' }}>Reading one line that encapsulates our love for photography and art is powerful and often reminds us of the importance of documenting moments with our cameras.</Card.Text>
                            
                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Wildlife Tours</span>
                                <span>80%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="success" now={80} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Outdoor Photography</span>
                                <span>65%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="secondary" now={65} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Industrial Photography</span>
                                <span>60%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="secondary" now={60} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Wedding Photography</span>
                                <span>70%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="success" now={70} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Event Photography</span>
                                <span>72%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="success" now={72} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Product Photography</span>
                                <span>45%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="danger" now={45} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Baby Photography</span>
                                <span>40%</span>
                            </Card.Text>
                            <ProgressBar className='mb-3' variant="danger" now={40} />

                            <Card.Text className='mb-0 d-flex align-items-center justify-content-between'>
                                <span>Fashion Photography</span>
                                <span>58%</span>
                            </Card.Text>
                            <ProgressBar variant="secondary" now={58} />
                        </Card.Body>
                    </Card>
                </Col>
            </Row>
        </div>
    );
};

export default Progress;